import classNames from 'classnames';
import React, { useState } from 'react';

import { AlmaLink } from '../alma-link';
import * as styles from './simple-roi-calculator.module.css';

export function SimpleRoiCalculator({ ctaAnalytics, sliderAnalytics }) {
	const [hours, setHours] = useState(20);
	const almaDefault = 4.7;
	const totalSavings = Math.round(hours * 52 - almaDefault * 52);

	const handleSliderChange = (event) => {
		const slider = event.target;
		const value = Number(slider.value); // Current value of the slider
		const trackWidth = slider.offsetWidth; // Track width (whole width of the slider container)
		const padding = 16; // 16px padding from both ends
		setHours(value);

		// Total width of the track minus the thumb width and the padding on both ends
		const availableWidth = trackWidth - 32;

		// Calculate the percentage of the range based on the current value
		const percent = (value - slider.min) / (slider.max - slider.min);

		// Calculate the width of the progress bar (in relation to the available width)
		const progressWidth = percent * availableWidth + padding;

		// Set the CSS variable for the progress width, including the left padding
		slider.parentElement.style.setProperty(
			'--range-progress',
			`${progressWidth}px`
		);
	};

	const handleSliderMouseDown = () => {
		if (sliderAnalytics?.enableGA4) {
			if (window?.gtag) {
				window.gtag('event', sliderAnalytics?.ga4Event?.name, {
					send_to: 'G-R0Z6J0E1GE',
					cta_name: 'slider',
				});
			}
		}
	};

	return (
		<div className={styles.container}>
			<h2 className='heading-s'>
				Time you spend on practice management:
			</h2>
			<div className={styles.sliderContainer}>
				<p
					className={classNames('body-m-bold', styles.hoursDisplay)}
					style={{
						left: `calc(var(--range-progress))`,
					}}
				>
					{hours}
				</p>
				<input
					type='range'
					min='5'
					max='50'
					step={1}
					value={hours}
					onChange={handleSliderChange}
					onMouseDown={handleSliderMouseDown}
					className={styles.slider}
				/>
				<div className={styles.sliderLabels}>
					<p className='body-m-bold'>5</p>
					<p className='body-m-bold'>hours per week</p>
					<p className='body-m-bold'>50</p>
				</div>
			</div>
			<div className={styles.resultCard}>
				<p className='heading-s'>An Alma membership could save you:</p>
				<p className='heading-l'>
					{Math.max(totalSavings, 0).toLocaleString()} hours per year
				</p>
			</div>
			<div className={styles.ctaContainer}>
				<p className='body-m'>Alma can save you money, too.</p>
				<AlmaLink
					analytics={ctaAnalytics}
					cta={{
						hasArrow: true,
						kind: 'link',
						linkColor: 'cgld',
						link: '/providers-savings-calculator',
						title: 'Calculate your potential savings',
					}}
				/>
			</div>
		</div>
	);
}
